import { render, staticRenderFns } from "./feng_mian.vue?vue&type=template&id=d696dac2&scoped=true&"
import script from "./feng_mian.vue?vue&type=script&lang=js&"
export * from "./feng_mian.vue?vue&type=script&lang=js&"
import style0 from "./feng_mian.vue?vue&type=style&index=0&id=d696dac2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d696dac2",
  null
  
)

export default component.exports